import React from 'react';
import { responseOptions } from '../data/questionnaireData';
interface QuestionFormProps {
  gender: string;
  answers: Record<string, number>;
  onAnswerChange: (questionIndex: number, value: number) => void;
  filteredQuestions: string[];
}
const QuestionForm: React.FC<QuestionFormProps> = ({
  gender,
  answers,
  onAnswerChange,
  filteredQuestions
}) => {
  return <div className="space-y-6" data-id="element-23">
      {filteredQuestions.map((question, index) => {
      // Skip rendering this question if it contains gender-specific text that doesn't match current gender
      if (gender === 'female' && question.includes('(Male only)') || gender === 'male' && question.includes('(Female only)')) {
        return null;
      }
      // Calculate the actual question number that corresponds to the original array
      const actualQuestionNum = index + 1;
      // Remove gender-specific text from the question
      const cleanedQuestion = question.replace('(Female only)', '').replace('(Male only)', '').trim();
      return <div key={`question-${actualQuestionNum}`} className="p-4 border border-gray-200 rounded-lg bg-[#fafafa]" data-id="element-24">
            <div className="font-medium mb-2.5 text-[#2c5530]" data-id="element-25">
              ({actualQuestionNum}) {cleanedQuestion}
            </div>
            <div className="flex flex-wrap gap-4" data-id="element-26">
              {responseOptions.map(option => <div key={`q${actualQuestionNum}_${option.value}`} className="flex items-center gap-1.5 p-2 px-3 border border-gray-300 rounded-full bg-white hover:bg-[#f0f8f0] hover:border-[#2c5530] cursor-pointer transition-colors" onClick={() => onAnswerChange(actualQuestionNum, option.value)} data-id="element-27">
                  <input type="radio" id={`q${actualQuestionNum}_${option.value}`} name={`q${actualQuestionNum}`} value={option.value} checked={answers[`q${actualQuestionNum}`] === option.value} onChange={() => onAnswerChange(actualQuestionNum, option.value)} className="m-0" data-id="element-28" />
                  <label htmlFor={`q${actualQuestionNum}_${option.value}`} className="cursor-pointer text-sm" data-id="element-29">
                    {option.label}
                  </label>
                </div>)}
            </div>
          </div>;
    })}
    </div>;
};
export default QuestionForm;